import { Injectable, Type } from '@angular/core';
import { Subject } from 'rxjs';
import { FormType } from '../../rl-common/forms/shared/form-type.enum';
import { EntityType } from '../../rl-common/shared/shared/entity-type.enum';
import { SectionItem } from '../../section/shared/section-item';
import { Section } from '../../store/model/section.model';
import { SidePanelStateComponent } from '../shared/side-panel-state-component';
import { SidePanelState } from '../shared/sidePanelStates/side-panel-state';
import { AddNewItemComponent } from '../states/add-new-item/add-new-item.component';
import { EditItemComponent } from '../states/edit-item/edit-item.component';

@Injectable({
  providedIn: 'root'
})
export class SidePanelService {

  sidePanelState$ = new Subject<SidePanelState>();
  sidePanelDisplay$ = new Subject<boolean>();

  defaultState : SidePanelState;

  constructor() { }

  //states
  addNewItemState : SidePanelState = new SidePanelState(AddNewItemComponent);
  editItemState : SidePanelState = new SidePanelState(EditItemComponent);
  //

  openAddNewItem(formType : FormType, itemType : EntityType, onAdd : (item : SectionItem) => any, section? : Section){
    this.addNewItemState.data = {
      section : section,
      type : formType,
      entity : itemType,
      onAdd : onAdd
    }
    
    this.sidePanelState$.next(this.addNewItemState);
  }

  editItem<T>(type : EntityType, item : T){
    if(item['section']) item['sectionId'] = item['section'].id;
    this.editItemState.data = {
      item : item,
      type : type
    }
    
    this.sidePanelState$.next(this.editItemState);
  }

  clear = () => this.sidePanelState$.next(this.defaultState);
  setDefaultState = (comp: Type<SidePanelStateComponent>) => this.defaultState = new SidePanelState(comp);


  hide = () => this.sidePanelDisplay$.next(false);
  show = () => this.sidePanelDisplay$.next(true);
}
